import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { getAuth, verifyPasswordResetCode, confirmPasswordReset } from 'firebase/auth';

const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const oobCode = searchParams.get('oobCode');
  const mode = searchParams.get('mode');

  useEffect(() => {
    if (mode !== 'resetPassword' || !oobCode) {
      setError('Invalid or missing reset link.');
      return;
    }
    const auth = getAuth();
    verifyPasswordResetCode(auth, oobCode)
      .then(() => setVerified(true))
      .catch(() => setError('Invalid or expired reset link.'));
  }, [mode, oobCode]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    const auth = getAuth();
    try {
      await confirmPasswordReset(auth, oobCode!, newPassword);
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError('Failed to reset password. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (error) return <div style={{maxWidth: 400, margin: '2rem auto', color: 'red'}}>{error}</div>;
  if (success) return <div style={{maxWidth: 400, margin: '2rem auto', color: 'green'}}>Password reset successful! Redirecting to login...</div>;

  return verified ? (
    <form onSubmit={handleSubmit} style={{maxWidth: 400, margin: '2rem auto', display: 'flex', flexDirection: 'column', gap: 16}}>
      <h2>Reset Your Password</h2>
      <input
        type="password"
        placeholder="New password"
        value={newPassword}
        onChange={e => setNewPassword(e.target.value)}
        required
        minLength={6}
        style={{padding: 8, fontSize: 16}}
      />
      <button type="submit" disabled={submitting || newPassword.length < 6} style={{padding: 10, fontSize: 16}}>
        {submitting ? 'Resetting...' : 'Reset Password'}
      </button>
    </form>
  ) : (
    <div style={{maxWidth: 400, margin: '2rem auto'}}>Verifying reset link...</div>
  );
};

export default ResetPassword; 